import * as staticDataService from "services/staticDataService";
import * as userService from "services/userService";

export const useIsVisible = (visibilityTag) => {
  const { data, isLoading } = userService.useAttributesQuery();

  return {
    isVisible: data?.config?.componentVisibility?.[visibilityTag],
    isLoading,
  };
};

export const useTranslator = (domain, hideEllipsis = false) => {
  const { data, isLoading } = staticDataService.useConfigQuery("translations");

  const translate = (key, options = { default: "" }) => {
    if (isLoading) {
      return hideEllipsis ? "" : "...";
    }
    let text = data?.[domain]?.[key] ?? options?.default;

    Object.entries(options?.replacements ?? {}).forEach(([key, value]) => {
      text = text.replace(`{${key}}`, value);
    });

    return text;
  };

  return translate;
};
